import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone } from "@phosphor-icons/react";
import { SITE } from "@/constants/site";

const LINKS = [
  { label: "Overview", href: "#overview" },
  { label: "Services", href: "#services" },
  { label: "Residences", href: "#residences" },
  { label: "Amenities", href: "#amenities" },
  { label: "Location", href: "#location" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  const textColor = scrolled ? "text-slate-800" : "text-white";

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,box-shadow] duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-white/40 shadow-[0_1px_0_rgba(10,10,10,0.05)]"
          : "bg-gradient-to-b from-black/50 to-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-12">
        <a href="#" data-testid="nav-brand" onClick={(e) => go(e, "#top")} className="flex items-center gap-3">
          <img
            src="/vr-logo.jpeg"
            alt="VR Ahmedabad Realtors logo"
            className="h-11 w-11 rounded-sm object-cover ring-1 ring-gold/50"
          />
          <span className="leading-tight">
            <span className={`block font-serif text-base tracking-tight ${textColor}`}>VR Ahmedabad Realtors</span>
            <span className={`block text-[10px] tracking-[0.25em] uppercase ${scrolled ? "text-forest/70" : "text-gold"}`}>
              Adani Shantigram
            </span>
          </span>
        </a>
        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={(e) => go(e, l.href)}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 hover:text-gold ${textColor}`}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/insights"
            data-testid="nav-link-insights"
            className={`text-sm font-medium tracking-wide transition-colors duration-200 hover:text-gold ${textColor}`}
          >
            Insights
          </Link>
          <Link
            to="/contact"
            data-testid="nav-link-contact"
            className={`text-sm font-medium tracking-wide transition-colors duration-200 hover:text-gold ${textColor}`}
          >
            Contact
          </Link>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={`tel:${SITE.phoneRaw}`}
            data-testid="nav-call-link"
            className={`hidden items-center gap-2 text-sm font-semibold md:flex ${textColor}`}
          >
            <Phone size={16} weight="fill" className="text-gold" />
            {SITE.phoneDisplay}
          </a>
          <a
            href="#enquire"
            data-testid="nav-enquire-btn"
            onClick={(e) => go(e, "#enquire")}
            className="rounded-sm bg-gold px-5 py-2.5 text-sm font-bold tracking-wide text-forest transition-colors duration-200 hover:bg-[#d4b274]"
          >
            Enquire Now
          </a>
        </div>
      </div>
    </header>
  );
}
